import React, { useMemo } from 'react';
import classnames from 'classnames';

// Flow container component
// @className: string | modifier className
// @children: array | container's children
export const Container = ({
	withAnimation,
	withBackground,
	withMarginTop,
	withMarginBottom,
	withPaddingAll,
	className,
	children
}) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'flow',
		withAnimation && 'flow--withAnimation',
		withBackground && 'withBackground',
		withMarginTop && 'withMarginTop',
		withMarginBottom && 'withMarginBottom',
		withPaddingAll && 'withPaddingAll',
		className
	), [
		withAnimation,
		withBackground,
		withMarginTop,
		withMarginBottom,
		withPaddingAll,
		className
	]);

	return <div className={cls}>{children}</div>;
};

// Flow column component
// @asOffset: boolean | should column be used as offset
// @asFlex: boolean | should column be as flex
// @asFlexEnd: boolean | should column be as flex end
// @itemCentered: boolean | should column be centered
// @labelOffset: boolean | should column be offseted
// @className: string | general modifier classNames
// @size: string | column's size
// @children: array | column's children
export const Column = ({
	size,
	asOffset,
	asFlexStart,
	asFlexEnd,
	asFlexBetween,
	className,
	children
}) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'flow__column',
		`flow__column--${size}`,
		asOffset && 'flow__column--asOffset',
		asFlexStart && 'flow__column--asFlexStart',
		asFlexEnd && 'flow__column--asFlexEnd',
		asFlexBetween && 'flow__column--asFlexBetween',
		className
	), [
		size,
		asOffset,
		asFlexStart,
		asFlexEnd,
		asFlexBetween,
		className
	]);

	return <div className={cls}>{children}</div>;
};
